module.exports = __webpack_public_path__ + "static/img/surpris.117d048.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/surpris.png
// module id = CyED
// module chunks = 0